const EditButton = ({handleEdit, id}) => {
    return (
        <td className="py-4 px-6 text-center">
            <svg
                className="h-6 w-6 text-blue-500 cursor-pointer hover:text-blue-700 transition duration-200 ease-in-out"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => handleEdit(id)}
            >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                      d="M12 20h9M16.5 3.5l4 4m-9.5 9.5H10v-2.5L18.5 7 21 9.5l-8.5 8.5z"></path>
            </svg>
        </td>
    )
}

export default EditButton